__turbopack_context__.v({
  "badge": "SoonBadge-module-scss-module__Z648eW__badge",
});
